<template>
  <div class="email-inputs-list">  
    <email-input :act="addEmailToList"></email-input>
    <invitations-list :act="removeEmailFromList" :emails="this.emails"></invitations-list>
  </div>
</template>

<script>
import EmailInput from '@/components/members/EmailInput'
import InvitationsList from '@/components/members/InvitationsList'

export default {
  components: {
    EmailInput,
    InvitationsList
  },
  data() {
    return {
      currentEmail: "",
      emails: []
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    addEmailToList: function(email) {
      if (email === this.user.email) {
        alert("You can't add your email to the list");
        return;
      }

      if (this.emails.indexOf({"email" : email}) == -1) {
        this.emails.unshift({"email" : email});
        this.$emit("update:emails", this.emails);
        email = "";
      } else {
        alert("This email has already been added");
      }
    },
    removeEmailFromList: function(index) {
      this.emails.splice(index, 1);
      this.$emit("update:emails", this.emails);
    }
  },
  beforeMount() {}
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.invitations-list {
  margin-top: 24px;
}
</style>